export function preventFraming() {
  try {
    if (window.top !== window.self) {
      window.top!.location.href = window.self.location.href;
    }
  } catch {
    // Cross-origin frame detected — can't redirect, but at least we know we're framed
    document.body.innerHTML = "<h1>This content cannot be displayed in a frame.</h1>";
  }
}
